var map = {
	"./E@2x.png": 166,
	"./ENE@2x.png": 167,
	"./ESE@2x.png": 168,
	"./N@2x.png": 169,
	"./NE@2x.png": 170,
	"./NNE@2x.png": 171,
	"./NNW@2x.png": 172,
	"./NW@2x.png": 173,
	"./S@2x.png": 174,
	"./SE@2x.png": 175,
	"./SSE@2x.png": 176,
	"./SSW@2x.png": 177,
	"./SW@2x.png": 178,
	"./W@2x.png": 179,
	"./WNW@2x.png": 180,
	"./WSW@2x.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 165;